<div [ngSwitch]="templateId" class="contractor-confirm-wrapper">
  <ng-container *ngSwitchCase="'commercialConfirmTemplate'">
    <ng-container *ngTemplateOutlet="commercialConfirmTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'ifpConfirmTemplate'">
    <ng-container *ngTemplateOutlet="ifpConfirmTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'maConfirmTemplate'">
    <ng-container *ngTemplateOutlet="maConfirmTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'csbConfirmTemplate'">
    <ng-container *ngTemplateOutlet="csbConfirmTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #commercialConfirmTemplate>
  <div id="toggleCommercial">
    <div class="confirm-box-title">
      {{ 'onboarding.lobContract.commercialHeader' | translate }}
    </div>
    <div class="confirm-box-sub-title">
      {{ 'onboarding.lobContract.commercialBody' | translate }}
    </div>

    <div class="btns">
      <button
        type="submit"
        mat-raised-button
        cg-mat-btn-type="primary"
        class="ls-button-fill"
        data-test-id="btn-submit"
        (click)="onYesClicked()"
      >
        Yes
      </button>
      <button
        mat-raised-button
        class="cancel-btn"
        data-test-id="btn-cancel"
        (click)="onNoClicked()"
      >
        No
      </button>
    </div>
  </div>
</ng-template>

<ng-template #ifpConfirmTemplate>
  <div id="toggleIfp">
    <div class="confirm-box-title">
      {{ 'onboarding.lobContract.ifpHeader' | translate }}
    </div>
    <div class="confirm-box-sub-title">
      {{ 'onboarding.lobContract.ifpBody' | translate }}
    </div>

    <div class="btns">
      <button
        type="submit"
        mat-raised-button
        cg-mat-btn-type="primary"
        class="ls-button-fill"
        data-test-id="btn-submit"
        (click)="onIfpYesClicked()"
      >
        Yes
      </button>
      <button
        mat-raised-button
        class="cancel-btn"
        data-test-id="btn-cancel"
        (click)="onIfpNoClicked()"
      >
        No
      </button>
    </div>
  </div>
</ng-template>

<ng-template #maConfirmTemplate>
  <div id="toggleMa">
    <div class="confirm-box-title">
      {{ 'onboarding.lobContract.maHeader' | translate }}
    </div>
    <div class="confirm-box-sub-title">
      {{ 'onboarding.lobContract.maBody' | translate }}
    </div>

    <div class="btns">
      <button
        type="submit"
        mat-raised-button
        cg-mat-btn-type="primary"
        class="ls-button-fill"
        data-test-id="btn-submit"
        (click)="onMaYesClicked()"
      >
        Yes
      </button>
      <button
        mat-raised-button
        class="cancel-btn"
        data-test-id="btn-cancel"
        (click)="onMaNoClicked()"
      >
        No
      </button>
    </div>
  </div>
</ng-template>

<ng-template #csbConfirmTemplate>
  <div id="toggleCsb">
    <div class="confirm-box-csb-title">
      {{ 'onboarding.lobContract.csbHeader' | translate }}
    </div>
    <div class="confirm-box-csb-sub-title">
      {{ 'onboarding.lobContract.csbBody' | translate }}
    </div>
    <div class="btns">
      <button
        type="submit"
        mat-raised-button
        cg-mat-btn-type="primary"
        class="ls-button-fill"
        data-test-id="btn-submit"
        (click)="onCsbYesClicked()"
      >
        Yes
      </button>
      <button
        mat-raised-button
        class="cancel-btn"
        data-test-id="btn-cancel"
        (click)="onCsbNoClicked()"
      >
        No
      </button>
    </div>
  </div>
</ng-template>
